type Join<K, P, S extends string = '.'> = K extends string | number
	? P extends string | number
		? `${K}${'' extends P ? '' : S}${P}`
		: never
	: never

type Prev = [
	never,
	0,
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11,
	12,
	13,
	14,
	15,
	16,
	17,
	18,
	19,
	20,
	...0[],
]

export type Leaves<T, D extends number = 10, S extends string = '.'> = [
	D,
] extends [never]
	? never
	: T extends object
		? {
				[K in keyof T]-?: Join<K, Leaves<T[K], Prev[D], S>, S>
			}[keyof T]
		: ''

export function flattenObject(obj: Record<string, any>, prefix = '') {
	return Object.keys(obj).reduce(
		(acc, k) => {
			const key = prefix ? `${prefix}.${k}` : k
			if (
				typeof obj[k] === 'object' &&
				obj[k] !== null &&
				!Array.isArray(obj[k])
			) {
				Object.assign(acc, flattenObject(obj[k], key))
			} else {
				acc[key] = obj[k]
			}
			return acc
		},
		{} as Record<string, any>,
	)
}
